import { OBJECTIVESTASKLIST_SUCCESS, OBJECTIVESTASKLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const objectivesTaskListReducer = (state = initialState, action) => {
    switch (action.type) {
        case OBJECTIVESTASKLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case OBJECTIVESTASKLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default objectivesTaskListReducer;
